// extracted by mini-css-extract-plugin
module.exports = {"bladeCrowdfunding":"crowdfunding_bladeCrowdfunding__Pb0pK"};